import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Play = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <g>
      <title>Paly icon</title>
      <g fill="none" fillRule="evenodd">
        <path d="M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 1c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6" fill="currentColor" />
        <path stroke="currentColor" d="M5 4v6l5-3z" />
      </g>
    </g>
  </Icon>
);
/*eslint-enable */

export default Play;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Play.js